'use strict';

export default function () {
  return function filter(value, opts) {
    opts = opts || {};
    if (value === null) {
      return opts.unknown || 'Unknown';
    } else if (value) {
      return 'Yes';
    } else {
      return 'No';
    }
  }
}
